export default {
  pickerUis: {
    default: '//static.filestackapi.com/picker/v3/picker-@{PICKER_VERSION}.js',
  },
};
